import React from "react";
import { Flame } from "lucide-react";
import { BeaconMedia } from "../pages/BeaconMedia";
import { beaconLook } from "../lib/beaconStyles";

// Banner with the title & tagline laid over it (or plain title block when there's no cover).
export const BeaconHero = ({ b, title, tagline, byline }) => {
  const L = beaconLook(b);
  const overlay = !!b.cover_media && b.title_position === "on";
  const shadow = overlay ? { textShadow: "0 2px 18px rgba(0,0,0,0.65)" } : {};
  const text = (
    <>
      <div className="flex items-center gap-2 min-w-0">
        <Flame size={22} className="shrink-0" style={{ color: L.accent }} />
        <h1 className="text-2xl sm:text-5xl leading-tight min-w-0 break-words" style={{ fontFamily: L.hFont, color: L.hColor, ...shadow }} data-testid="beacon-hero-title">{title ?? b.title}</h1>
      </div>
      <div className="text-base sm:text-xl mt-1 opacity-85" style={{ fontFamily: L.tFont, color: L.tColor, ...shadow }} data-testid="beacon-hero-tagline">{tagline ?? b.tagline}</div>
      {byline && <p className="font-body text-sm text-zinc-300/80 mt-2">{byline}</p>}
    </>
  );
  if (!b.cover_media) return <div className="mb-5" data-testid="beacon-hero">{text}</div>;
  if (!overlay) return (
    <div className="mb-6" data-testid="beacon-hero">
      <div className="w-full overflow-hidden rounded border border-white/10 mb-5" style={{ aspectRatio: L.banner.ratio }}>
        <BeaconMedia path={b.cover_media} type="image" className="w-full h-full object-cover" />
      </div>
      {text}
    </div>
  );
  // Overlay: the box keeps the banner shape but grows taller if the title needs room.
  return (
    <div className="relative w-full mb-6 flex flex-col justify-end" style={{ aspectRatio: L.banner.ratio, minHeight: L.banner.minH }} data-testid="beacon-hero">
      <div className="absolute inset-0 overflow-hidden rounded border border-white/10">
        <BeaconMedia path={b.cover_media} type="image" className="w-full h-full object-cover" />
        <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(to top, rgba(10,10,10,0.92) 0%, rgba(10,10,10,0.45) 45%, rgba(10,10,10,0) 80%)" }} />
      </div>
      <div className="relative p-5 sm:p-8 pt-10">{text}</div>
    </div>
  );
};
